import axios from "axios";


const statisticsBaseUrl = process.env.REACT_APP_GITO_API_URL + "/Telemetry/ChargingSiteStatistics";
//const statisticsBaseUrl = "https://localhost:7241/ChargingSiteStatistics";

const logsBaseUrl = process.env.REACT_APP_GITO_API_URL + "/Telemetry/Logs";
//const logsBaseUrl = "https://localhost:7241/Logs";

const forecastBaseUrl = process.env.REACT_APP_GITO_API_URL + "/Telemetry/ConsumptionForecast";
//const forecastBaseUrl = "https://localhost:7241/ConsumptionForecast";


export async function getSiteStatisticsPower15min(apiAccessToken, filter) {
    try {
        const response = await axios.post(
            `${statisticsBaseUrl}/site-statistics-15min-power-peak`,
            filter,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch session statistics chart"
        );
    }
}

export async function getSitesForStatistic(apiAccessToken, filter) {
    try {
        const response = await axios.post(
            `${statisticsBaseUrl}/site-statistics-connector-statuses`,
            filter,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch session statistics chart"
        );
    }
}


export async function getLogs(apiAccessToken, filter) {
    try {
        const response = await axios.post(
            `${logsBaseUrl}/get-Logs`,
            filter,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || "Failed to fetch session statistics chart"
        );
    }
}

export async function getForecastVsActual(apiAccessToken, filter) {
    try {
        const response = await axios.post(
            `${forecastBaseUrl}/get-forecast-vs-actual`,
            filter,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${apiAccessToken}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(
            error.response?.data?.detail || error.response?.data?.title || "Failed to fetch forecast vs actual data"
        );
    }
}